import React from 'react';
import { BygrProfileDetails, BygrProject } from 'types';
import { createDataTable } from 'components/DataTable';
import { CustomLink, DateDistanceDisplay, LoadingIndicator } from '@ygtechnologies/bygr-frontend-component-library';
import { getProfileContractorProjects } from 'services/profiles';
import { useAsyncState } from 'utils/hooks';
// import theme from './ProjectDetails.module.scss';

interface Props {
    profile: BygrProfileDetails;
    reloadProfile(): void;
}
const ProjectTable = createDataTable<BygrProject>();
export const ProfileContractorProjects: React.FC<Props> = ({ profile, reloadProfile }) => {
    const [data] = useAsyncState(() => getProfileContractorProjects(profile.id), [profile.id], null);
    if (!data) {
        return <LoadingIndicator />;
    }
    return (
        <>
            <ProjectTable
                hasPagination={false}
                data={data}
                onStateChange={() => {}}
                state={ProjectTable.getInitialState('id')}
                totalItemCount={data.length}
                className="table style-3">
                <ProjectTable.Column header="Id" field="id" />

                <ProjectTable.Column
                    header="Name"
                    field="name"
                    renderer={({ row, value }) => <CustomLink to={`/projects/${row.id}`}>{value}</CustomLink>}
                />
                <ProjectTable.Column header="Units" field="numberOfUnits" />
                <ProjectTable.Column
                    header="Created"
                    field="createDate"
                    renderer={(x) => x.value && <DateDistanceDisplay value={x.value} />}
                />
            </ProjectTable>
        </>
    );
};
